import Calendar, { CalendarProps } from '@/components/Calendar/new';

import FormWatch from '@/common/Form/FormWatch';
import { fieldWrapper } from '@/components/Field';
import { forwardRef } from 'react';

export type CalendarInputProps = {
  name: any;
  value?: string | string[];
  onChange?: (value: string[]) => void;
  isValid?: boolean;
  isInvalid?: boolean;
  isDirty?: boolean;
} & Partial<Omit<CalendarProps, 'onChange' | 'value' | 'multiple'>>;

const CalendarInput = forwardRef<HTMLDivElement, CalendarInputProps>(
  ({ name, value, onChange, isValid, isInvalid, isDirty, ...calendarProps }, ref) => {
    return (
      <FormWatch name={name}>
        {([calendarValue]: [string | string[]] = [[]]) => {
          const currentValues = Array.isArray(calendarValue) ? calendarValue : calendarValue ? [calendarValue] : [];

          return (
            <Calendar
              ref={ref}
              onChange={(date) => {
                const dateExists = currentValues.includes(date);
                const newValue = dateExists ? currentValues.filter((d) => d !== date) : [...currentValues, date];
                onChange?.(newValue);
              }}
              value={currentValues}
              multiple={true}
              isValid={isValid}
              isInvalid={isInvalid}
              isDirty={isDirty}
              {...calendarProps}
            />
          );
        }}
      </FormWatch>
    );
  }
);

CalendarInput.displayName = 'CalendarInput';

const CalendarField = fieldWrapper<CalendarInputProps>(CalendarInput, 'Calendar');

export default CalendarField;
